import {AnswerModel} from './AnswerModel.js';
import {AnswerQuestion} from './AnswerQuestion.js';
import {PollRobotTemplate} from './PollRobotTemplate.js';

export class AnswerPoll {
	constructor(parent, pollModel, askId) {
		this.model = pollModel;
		this.answerModel = new AnswerModel(pollModel, askId);
		[this.el, this.$] = PollRobotTemplate("AnswerPoll");

		this.$.title.innerText = this.model.title;
		this.questions = this.model.questions.map( 
			q=>new AnswerQuestion(this.$.questions, this.answerModel, q) );

		this.$.close.addEventListener(`click`, evt=>{
			this.hideAndRemove();
		});
		this.$.submit.addEventListener(`click`, evt=>{
			evt.preventDefault(); evt.stopPropagation();
			this.submitAnswer();
		});

		parent.appendChild(this.el);
	}
	hideAndRemove() {
		let done = (evt)=>{
			this.el.removeEventListener(`transitionend`, done);
			this.el.remove();
			console.log(`removed el`);
		}
		this.el.addEventListener(`transitionend`, done);
		this.el.classList.add(`removing`);
	}
	submitAnswer() {
		let comp =this.answerModel.isComplete(); 
		if (!comp) {
			return;
		}
		this.el.dispatchEvent(new CustomEvent(`pollrobot-answer-submit`, {
			bubbles: true,
			composed: true,
			detail: this.answerModel.object()
		}));
	}
}